import numeral from 'numeral';

export const toString = data => {
  if (data === null) {
    return '';
  }

  if (typeof data === 'boolean' || typeof data === 'number') {
    return data.toString();
  }

  if (typeof data === 'string') {
    return data;
  }

  if (typeof data === 'symbol') {
    throw new TypeError();
  }

  return JSON.stringify(data);
};

export const decimalWithSignFormatter = value => {
  if (isNaN(value) || value === '') {
    return '';
  }
  const result = numeral(value).format('0.000000');
  if (isNaN(result)) {
    return Number(value).toFixed(8);
  }
  return result;
};
